// extracted by mini-css-extract-plugin
module.exports = {"faqSearchForm":"FaqSearchForm_faqSearchForm__TYrHy","inputWrap":"FaqSearchForm_inputWrap__eREF_","input":"FaqSearchForm_input__LsHb5","submit":"FaqSearchForm_submit__gc0IR"};